import { render, staticRenderFns } from "./GroupPublications.vue?vue&type=template&id=4c957da0&scoped=true&"
import script from "./GroupPublications.vue?vue&type=script&lang=js&"
export * from "./GroupPublications.vue?vue&type=script&lang=js&"
import style0 from "./GroupPublications.vue?vue&type=style&index=0&id=4c957da0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c957da0",
  null
  
)

export default component.exports